<template>
	<div :class="pageTheme ? 'block-theme--' + pageTheme : ''" class="person-block-popup">
		<WpImage :radius="true" size="medium" cover lazy background :image="data.person_data.acf.photo" />
		<div class="person-info">
			<h3 class="name font-size--26">
				<span class="firstname">
					{{ data.person_data.acf.first_name }}
				</span>
				<span class="lastname">
					{{ data.person_data.acf.last_name }}
				</span>
			</h3>
			<div v-if="data.person_data.acf.position" class="position">
				{{ data.person_data.acf.position }}
			</div>
			<div v-if="data.person_data.acf.company" class="company">
				{{ data.person_data.acf.company }}
			</div>
			<div v-if="data.contact_info" class="contact">
				<a
					class="phone"
					:href="'tel:' + data.person_data.acf.phone.phoneFormat()"
					v-if="data.person_data.acf.phone"
				>
					{{ data.person_data.acf.phone }}
				</a>
				<a class="email" :href="'mailto:' + data.person_data.acf.email" v-if="data.person_data.acf.email">
					{{ data.person_data.acf.email }}
				</a>
			</div>

			<div class="more-info html-content" v-html="data.person_data.acf.more_info"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import WpImage from '@/components/elements/WpImage'

export default {
	props: ['data'],
	components: {
		WpImage,
	},
	data() {
		return {
			showingMoreInfo: false,
		}
	},
	computed: {
		...mapGetters(['pageTheme']),
		plus() {
			return plus('#222831')
		},
	},
	metaInfo() {
		return {
			htmlAttrs: {
				class: ['show-popup', 'popup-person-show'],
			},
		}
	},
	methods: {
		showInfo(infoId) {
			if (!this.showingMoreInfo) {
				this.showingMoreInfo = infoId
			} else {
				this.showingMoreInfo = false
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
html.popup-person-show {
	.theme-header {
		display: none;
		z-index: 10 !important;
	}
}
.person-block-popup {
	display: flex;
	align-items: flex-start;
	@include mquery($phone) {
		flex-direction: column;
	}

	.person-info {
		padding-left: 50px;
		@include mquery($tablet) {
			padding-left: 30px;
		}
		@include mquery($phone) {
			padding-left: 0;
			margin-top: 20px;
		}

		flex-grow: 1;
		.lastname {
			margin-left: 5px;
		}
		.name {
			margin-top: 0;
			margin-bottom: 15px;
		}
		.show-more-info {
			padding: 0;
			margin: 0;
			box-shadow: none;
			border: none;
			margin-top: 25px;
			background-color: transparent;
			display: inline-flex;
			font-weight: 600;
			align-items: center;
			cursor: pointer;
			.icon {
				margin-right: 15px;
			}
			.icon,
			svg {
				line-height: 1;
			}
			svg {
				width: 15px;
				height: 15px;
			}
		}
		.company {
			margin-top: 5px;
		}
		.contact {
			margin-top: 15px;
			a {
				display: inline-block;
				margin-right: 25px;
				text-decoration: none;
				&:last-child {
					margin-right: 0;
				}
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	.wp-image-vue {
		min-width: 150px;
		max-width: 150px;
	}
	.wp-image-vue.background div.image {
		padding: 0;
		min-height: 150px;
		height: initial;
	}
}
</style>
